import { useState , useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import ListItemText from '@mui/material/ListItemText';

function EditStaff(props) {
  const [open, setOpen] = useState(false);
  const { passedStaff, allRoles, editStaff, updateRoles } = props;
  const [staffValues, setStaffValues] = useState({
    notes: '',
    username: '',
    roles: [],
    policecheck: false,
    dsl: false, 
    firstaid: false
  });

  useEffect(() => {
    if (passedStaff) {
      setStaffValues({
        notes: passedStaff.notes || '',
        username: passedStaff.username || '',
        roles: passedStaff.roles || [],
        policecheck: passedStaff.policecheck || false,
        dsl: passedStaff.dsl || false, 
        firstaid: passedStaff.firstaid || false
      });
    }
  }, [passedStaff]);

  const handleClickOpen = () => {
    setStaffValues({
      notes: passedStaff.notes || '',
      username: passedStaff.username || '',
      roles: passedStaff.roles || [],
      policecheck: passedStaff.policecheck || false,
      dsl: passedStaff.dsl || false, 
      firstaid: passedStaff.firstaid || false
    });      
    setOpen(true);
  }
    
  const handleClose = () => {
    setOpen(false);
  };
      
  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setStaffValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRolesChange = (e) => {
    const {
      target: { value }
    } = e;
    // value is an array of selected role names
    setStaffValues((prev) => ({
      ...prev,
      roles: typeof value === 'string' ? value.split(',') : value
    }));
  };
    
  const handleSave = () => {
    console.log("Saving staff with:", {
    notes: staffValues.notes,
    username: staffValues.username,
    policecheck: staffValues.policecheck,
    dsl: staffValues.dsl,
    firstaid: staffValues.firstaid
}, "ID:", passedStaff.staffid);
    editStaff(
      {
        notes: staffValues.notes,
        username: staffValues.username,
        policecheck: staffValues.policecheck,
        dsl: staffValues.dsl,
        firstaid: staffValues.firstaid
      },
      passedStaff.staffid
    );
    updateRoles(staffValues.roles, passedStaff.staffid);

    handleClose();
  }
    
      return(
        <div>
          <IconButton onClick={handleClickOpen}><EditIcon color="primary"/></IconButton>
          <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Edit Staff</DialogTitle>
              <DialogContent>
                <Stack spacing={2} mt={1}> 
                
                <TextField label="notes" name="notes" 
                            variant="standard" value={staffValues.notes} 
                            onChange={handleFieldChange}/> 
                          <TextField label="username" name="username" 
                            variant="standard" value={staffValues.username} 
                            onChange={handleFieldChange}/> 
                            <FormControl fullWidth>
                <FormControlLabel
                  control={
                  <Checkbox
                    checked={staffValues.policecheck}
                    onChange={(e) =>
                    setStaffValues((prev) => ({
                      ...prev,
                    policecheck: e.target.checked
                    }))
                  }
                  name="policecheck"
                  color="primary"
                  />
                  }
                label="Police Check Completed"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={staffValues.dsl}
                      onChange={(e) =>
                        setStaffValues((prev) => ({
                        ...prev,
                        dsl: e.target.checked
                        }))
                      }
                      name="dsl"
                      color="primary"
                    />
                  }
                  label="DSL Trained"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={staffValues.firstaid}
                      onChange={(e) =>
                        setStaffValues((prev) => ({
                          ...prev,
                          firstaid: e.target.checked
                        }))
                      }
                    name="firstaid"
                    color="primary"
                    />
                  }
                  label="First Aid Qualified"
                />

              <InputLabel id="roles-select-label">Roles</InputLabel>
              <Select
                labelId="roles-select-label"
                multiple
                value={staffValues.roles}
                onChange={handleRolesChange}
                renderValue={(selected) => selected.join(', ')}
                label="Roles"
              >
                {allRoles.map((roleName) => (
                  <MenuItem key={roleName} value={roleName}>
                    <Checkbox
                      checked={staffValues.roles.includes(roleName)}
                    />
                    <ListItemText primary={roleName} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
                </Stack>
              </DialogContent>    
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>
              </DialogActions>
            </Dialog>            
        </div>
      );  
}    

export default EditStaff;
